import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

// import { Logger, LoggerTypes } from '../../../../utils'
import { FlowElementTaskTab, FlowElementStartTab, FlowElementConditionTab, FlowElementEndTab } from '../elements'
import './style.scss'

/**
 *
 * @param {object} currentProject Object of the current selected project.
 * @param {object} currentScenario Object of the current selected scenario.
 * @param {object} currentFlowGroup Object of the current selected flow group.
 * @param {object} resourceItems Scenario's resources
 * @param {object} productItems Scenario's  products
 * @param {object} variableItems Scenario's variables
 * @param {object} locationItems Scenario's location
 * @param {object} weatherItems Scenario's weather
 * @param {object} parameterItems Scenario's parameters
 * @param {object} alphaFactorItems Global alpha factors values
 * @param {object} taskItems Scenario's flow's tasks
 * @param {object} conditionItems Scenario's flow's condition
 * @returns {div}
 */
export const FlowElements = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  // -- Scenario's Attributes
  resourceItems,
  productItems,
  variableItems,
  locationItems,
  weatherItems,
  parameterItems,
  // -- Flow Actions + AlphaFactors
  alphaFactorItems,
  taskItems,
  conditionItems,
  // -- refresh after saving
  refreshAfterSave
}) => {
  const currentElement = useSelector((state) => state.flowGroupElements)

  /**
   * Bind the corresponding view accordingly with its type.
   * The types are broadcasted by JQuery BpmnModeler.
   *
   * @see /containers/flowGroups/center/Bpmn/BpmnModeler.jsx
   * In section this.on('element.click', {...})
   */
  const tabViews = [
    { viewClass: FlowElementTaskTab, type: 'bpmn:Task' },
    { viewClass: FlowElementStartTab, type: 'bpmn:StartEvent' },
    { viewClass: FlowElementEndTab, type: 'bpmn:EndEvent' },
    { viewClass: FlowElementConditionTab, type: 'bpmn:ExclusiveGateway' },
    { viewClass: FlowElementEndTab, type: 'bpmn:IntermediateCatchEvent' }
  ]

  const ViewClass = (currentElement && tabViews.filter((el) => el.type === currentElement?.type)[0]?.viewClass) || null

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowElements.render()', {
  //   currentProject,
  //   currentScenario,
  //   currentFlowGroup,
  //   currentElement,
  //   attributes: {
  //     resourceItems,
  //     productItems,
  //     variableItems,
  //     locationItems,
  //     weatherItems,
  //     parameterItems
  //   },
  //   flowAction: {
  //     alphaFactorItems,
  //     taskItems,
  //     conditionItems
  //   }
  // })

  return (
    currentProject &&
    currentScenario &&
    currentFlowGroup &&
    currentElement && (
      <div className="FlowElements">
        {ViewClass && (
          <ViewClass
            currentProject={currentProject}
            currentScenario={currentScenario}
            currentFlowGroup={currentFlowGroup}
            currentElement={currentElement}
            // -- Scenario's Attributes
            resources={resourceItems}
            variables={variableItems}
            products={productItems}
            locations={locationItems}
            weather_data={weatherItems}
            parameters={parameterItems}
            // -- Flow Actions
            alphaFactors={alphaFactorItems}
            tasks={taskItems}
            conditions={conditionItems}
            // -- refresh after saving
            refreshAfterSave={refreshAfterSave}
          />
        )}
      </div>
    )
  )
}

FlowElements.displayName = 'FlowElements'

FlowElements.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  currentFlowGroup: PropTypes.object,
  // -- Scenario's attributes
  resourceItems: PropTypes.arrayOf(PropTypes.object),
  productItems: PropTypes.arrayOf(PropTypes.object),
  variableItems: PropTypes.arrayOf(PropTypes.object),
  locationItems: PropTypes.arrayOf(PropTypes.object),
  weatherItems: PropTypes.arrayOf(PropTypes.object),
  parameterItems: PropTypes.arrayOf(PropTypes.object),
  // -- Flow's Actions + AlphaFactors
  alphaFactorItems: PropTypes.any,
  taskItems: PropTypes.arrayOf(PropTypes.object),
  conditionItems: PropTypes.arrayOf(PropTypes.object),
  // -- refresh after saving
  refreshAfterSave: PropTypes.func
}

FlowElements.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  // -- Scenario's attributes
  resourceItems: [],
  productItems: [],
  variableItems: [],
  locationItems: [],
  weatherItems: [],
  parameterItems: [],
  // -- Flow's Actions + AlphaFactors
  alphaFactorItems: [],
  taskItems: [],
  conditionItems: [],
  // -- refresh after saving
  refreshAfterSave: null
}
